const initState = {
    profile: null,
    isAdmin: false,
    isReportingOperator: false,
    isRefillOperator: false,
    isLocationRestricted: true,
    isLoading: true,
};

export default function user(state = initState, action) {
    switch (action.type) {
        case 'PROFILE_DATA_RECEIVED': {
            //check if the user has right to edit/update cabinet
            const cabinetOperators = ['Admin', 'Administrator', 'Cabinet Operator'];
            const reportingOperators = ['Reporting Operator'];
            const refillOperators = ['Refill Operator'];
            const roles = action.profile.roles;
            const cabinetOperatorRoles = Array.isArray(roles) ? roles.filter(role => cabinetOperators.includes(role)) : [];
            const reportingOperatorRoles = Array.isArray(roles) ? roles.filter(role => reportingOperators.includes(role)) : [];
            const refillOperatorRoles = Array.isArray(roles) ? roles.filter(role => refillOperators.includes(role)) : [];

            return {
                ...state,
                isLoading: false,
                profile: action.profile,
                isAdmin: cabinetOperatorRoles.length > 0,
                isReportingOperator: reportingOperatorRoles.length > 0,
                isRoot: action.profile.accessScope === 'Root',
                isRefillOperator: refillOperatorRoles.length > 0,
                isLocationRestricted: action.profile.modules && Array.isArray(action.profile.modules) && action.profile.modules.length > 0,
            };
        }
        case 'SELECT_GROUP':
            return {
                ...state,
                group: action.group,
            };
        default:
            return state;
    }
}
